import { Error } from "@/components/admin/error";
import { Notification } from "@/components/admin/notification";
import { Skeleton } from "@/components/ui/skeleton";
import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { MobileNavigation } from "./MobileNavigation";
import { HelpPanel } from "../help/HelpPanel";
import { InstallHint } from "./InstallHint";
import { CallTracker } from "../calls/CallTracker";

export const MobileLayout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <>
      <ErrorBoundary FallbackComponent={Error}>
        <Suspense fallback={<Skeleton className="h-12 w-12 rounded-full" />}>
          {children}
        </Suspense>
      </ErrorBoundary>
      <MobileNavigation />
      {/* LDF: Hilfe steckt im „Mehr“-Menü, damit kein schwebender Knopf Inhalte verdeckt */}
      <HelpPanel />
      <InstallHint />
      <CallTracker />
      <Notification mobileOffset={{ bottom: "calc(72px + env(safe-area-inset-bottom))" }} />
    </>
  );
};
